import isNil from 'lodash/isNil';

type FormValue = boolean | number | string;

export type FormValues = {
	[key: string]: FormValue | FormValue[];
};

export function isDefined(value: unknown) {
	if (typeof value === 'string' && value.trim() === '') {
		return false;
	}
	return !isNil(value);
}

export function getFormValues(formElement: HTMLFormElement) {
	return Array.from(formElement.elements).reduce((acc: FormValues, element) => {
		const input = element as HTMLInputElement;
		if (input.name) {
			switch (input.type) {
				case 'checkbox':
				case 'radio':
					acc[input.name] = input.checked;
					break;
				case 'number':
					acc[input.name] = +input.value;
					break;
				case 'select-one':
					acc[input.name] = input.value;
					break;
				default:
					acc[input.name] = input.value;
			}
		}
		return acc;
	}, {});
}

export type FormErrors = {
	[name: string]: string[];
};

export const validateForm = (formValues: FormValues) => {
	return Object.keys(formValues).reduce((errors: FormErrors, name: string) => {
		const value = formValues[name];

		if ('boolean' === typeof value || 'number' === typeof value) {
			return errors;
		}

		if (isNil(value)) {
			const msg = `Invalid value: ${name}`;
			return addErrorMessage(errors, name, msg);
		}

		if ('string' === typeof value) {
			if (!value.trim()) {
				const msg = `Invalid value: ${name}`;
				addErrorMessage(errors, name, msg);
			}
			return errors;
		}

		return errors;
	}, {});
};

export function addErrorMessage(errors: FormErrors, name = '', message = '') {
	if (errors[name]) {
		errors[name].push(message);
	} else {
		errors[name] = [message];
	}
	return errors;
}

export function formatErrors(errors: FormErrors, translate: (key: string) => string) {
	return Object.keys(errors).reduce((err: { [key: string]: string }, key) => {
		err[key] = errors[key].map(i => translate(i)).join('. ');
		return err;
	}, {});
}
